import React from 'react';
import { Box } from '@mui/material';
import { tok } from '../theme/businessTheme';
import { keyframes } from '@mui/system';

const bounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.3;
  }
  30% {
    transform: translateY(-4px);
    opacity: 1;
  }
`;

const TypingIndicator: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        padding: 1.5,
        width: '64px',
        borderRadius: '18px',
        borderBottomLeftRadius: '6px',
        backgroundColor: tok('businessBubble'),
        ml: 0,
        mb: 1,
      }}
    >
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: tok('onBusinessBubble'),
            mx: 0.5,
            animation: `${bounce} 1.5s infinite ease-in-out`,
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </Box>
  );
};

export default TypingIndicator;